import api from '../../services/api';

export default {
  namespaced: true,
  state: {
    programDraftMovementId: null,
    programDraftMovementAmount: null,
    programDraftMovementsChildren: [],
    programDraftMovementTotalAssets: null,
    programDraftMovementData: null
  },
  getters: {
    isDraftSimulated: state => {
      if (!state.programDraftMovementId) return false
      const data = state.programDraftMovementData || {}
      return Object.keys(data).some(key => key.indexOf('criteria_') === 0)
    }
  },
  mutations: {
    setDraftMovementsId(state, payload) {
      state.programDraftMovementId = payload
    },
    setDraftMovementsAmount(state, payload) {
      state.programDraftMovementAmount = payload
    },
    setDraftMovementsTotalAssets(state, payload) {
      state.programDraftMovementTotalAssets = payload
    },
    setDraftMovementsChildren(state, payload) {
      state.programDraftMovementsChildren = payload
    },
    setProgramDraftMovementData(state, payload) {
      state.programDraftMovementData = payload
    }
  },
  actions: {
    async apiGetDraftMovements({commit}, payload) {
      const result = await api.get(`/draft_movements/${payload}`, {
        validateStatus: function (status) {
          return status == 200 || status == 204;
        }
      });
      commit("setProgramDraftMovementData", result.data.data)
      switch (result.status) {
        case 200:
          commit("setDraftMovementsId", result.data.data.id)
          commit("setDraftMovementsAmount", result.data.data.amount)
          if(result.data.data.total_assets){
            commit("setDraftMovementsTotalAssets", result.data.data.total_assets)
          }
        break
        case 204:
          commit("setDraftMovementsId", null)
          commit("setDraftMovementsAmount", null)
          commit("setDraftMovementsTotalAssets", null)
        break
      }

      return result
    },
    async apiGetDraftMovementsChildren({commit}, payload) {
      const {type, id} = payload
      const result = await api.get(`/draft_movements/${type}/${id}/children`)
      commit("setDraftMovementsChildren", result.data.content)
      return result
    },
    async apiUpdateDraftMovement({commit}, payload) {
      const {type, data} = payload
      let endpoint = `/draft_movements/${type}`
      await api.put(endpoint, data)
    },
    async apiCreateDraftMovement({commit}, payload) {
      const {type, data} = payload

      const result = await api.post(`/draft_movements/${type}`, data)

      // garante o header Location (o backend/CORS pode não expô-lo),
      // buscando o id do draft recém-criado e sintetizando-o
      if (result && result.headers && !result.headers.location) {
        const current = await api.get(`/draft_movements/${type}`, {
          validateStatus: (status) => status === 200 || status === 204
        })
        const id = current.data && current.data.data ? current.data.data.id : null
        if (id) {
          result.headers.location = `/draft_movements/${type}/${id}`
        }
      }

      return result
    },
    async apiDeleteDraftMovement({commit}, payload) {
      const {type} = payload
      const result = await api.delete(`/draft_movements/${type}`)
      return result
    },
    async apiSendDraftMovementChildren({commit}, payload) {
      const {type, id, data} = payload
      const result = await api.put(`/draft_movements/${type}/${id}/children`,
        data)
      return result
    },
    async apiDeleteDraftMovementChild({commit}, payload) {
      const {type, idDraft, idChild, data} = payload
      const result = await api.delete(`/draft_movements/${type}/${idDraft}/children/${idChild}`,
        data)
      return result
    }
  }
}
